module.exports = __webpack_public_path__ + "assets/img/jtfx32.81e217c2.jpg";